/**
 * @fileoverview Branding Panel Component
 *
 * Renders the left-side branding panel with logo and floating clock.
 */

import React from 'react';
import clockwiseLogo from '../../../assets/clockwise.png';

/**
 * Branding Panel Component
 *
 * @returns {JSX.Element} Branding panel component
 */
const BrandingPanel = () => {
  return (
    <div className="lp-branding-panel">
      <div className="lp-brand-logo">
        <div className="lp-logo-icon">
          <img src={clockwiseLogo} alt="Clockwise" className="lp-logo-image" />
        </div>
        <span>Clockwise CPA</span>
      </div>

      <div className="lp-brand-content">
        <h2 className="lp-brand-tagline">
          When every minute counts, work <strong>Clockwise.</strong>
        </h2>
      </div>

      {/* Floating Clock */}
      <div className="lp-floating-clock">
        <div className="lp-clock-face">
          <div className="lp-clock-hand lp-clock-hour"></div>
          <div className="lp-clock-hand lp-clock-minute"></div>
          <div className="lp-clock-center"></div>
        </div>
      </div>
    </div>
  );
};

export default BrandingPanel;
